var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uikit-form" },
    [
      _c("h3", { staticClass: "layout__subtitle" }, [_vm._v("Спиннер")]),
      _c("loader", {
        attrs: { label: "Данные загружаются", active: true, height: "300" },
      }),
      _c("div", { staticClass: "layout__hr" }),
      _c("h3", { staticClass: "layout__subtitle" }, [
        _vm._v("Дефолтный аватар"),
      ]),
      _c("img", { attrs: { width: "70px", src: _vm.userpic } }),
      _c("div", { staticClass: "layout__hr" }),
      _c("h3", { staticClass: "layout__subtitle" }, [
        _vm._v('Кнопка "Наверх"'),
      ]),
      _c("div", [_vm._v("появится при скролле")]),
      _c("div", { staticStyle: { height: "1000px" } }),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }